import { createFileRoute } from "@tanstack/react-router";
import { DashboardIAPage } from "@/components/intelligence/DashboardIA";

export const Route = createFileRoute("/dashboard-ia")({
  head: () => ({
    meta: [
      { title: "Dashboard IA — LicitaPro" },
      {
        name: "description",
        content:
          "Dashboard ejecutivo del Motor IA: scoring real, heatmap de actividad y top oportunidades.",
      },
      { property: "og:title", content: "Dashboard IA — LicitaPro" },
      {
        property: "og:description",
        content: "Inteligencia estratégica para licitaciones públicas con datos reales.",
      },
    ],
  }),
  component: DashboardIAPage,
});
